export const INTERNAL_BUSINESS_TYPES = Object.freeze([
  10, // 谈判人
  20, // 商务
  30, // 监督人
  40, // 验货人
  50, // 融资人
  60, // 财务
  70, // 审核人
  80, // 法务
  91, // 业务
]);

const INTERNAL_BUSINESS_TYPE_SET = new Set(INTERNAL_BUSINESS_TYPES);

function normalizeBusinessTypes(value) {
  if (Array.isArray(value)) {
    return value.flatMap((item) => normalizeBusinessTypes(item));
  }
  if (value === null || value === undefined || value === "") return [];
  if (typeof value === "number") return Number.isFinite(value) ? [value] : [];
  return (String(value).match(/\d+/g) || []).map(Number);
}

export function isInternalBusinessType(value) {
  return normalizeBusinessTypes(value).some((type) =>
    INTERNAL_BUSINESS_TYPE_SET.has(type),
  );
}

function firstDefinedUserField(users, field) {
  const user = users.find(
    (item) =>
      item &&
      Object.prototype.hasOwnProperty.call(item, field) &&
      item[field] !== undefined,
  );
  return user ? user[field] : undefined;
}

export function canAccessInternalRemark(...users) {
  const privateRole = Number(firstDefinedUserField(users, "privateRole") || 0);
  const businessType = firstDefinedUserField(users, "businessType");
  return privateRole > 0 || isInternalBusinessType(businessType);
}
